export const TimezoneService = Symbol.for('TimezoneService');
